export const syncSettings = {
    /**
     * How long to keep reporting "syncing" right after a force sync starts, to bridge the gap
     * before the backend reflects it in the store's sync state.
     */
    optimisticSyncingMs: 60_000,
}
